<template>
  <!-- <SideNav /> -->
  <div id="listpage" class="flexTopCol">
    <div class="lists">
      <h1 style="margin-left: 5px">My Workflows</h1>
      <div class="flexSpaceBetweenRow">
        <div class="listNav flexLeftRow">
          <NavButton
            :text="'Live Workflows'"
            :icon="Zap"
            :selectHighlight="currentView == 'activeWorkflows'"
            :isSelected="currentView == 'activeWorkflows'"
            @click="currentView = 'activeWorkflows'"
            width="170px"
          />
          <NavButton
            :text="'Drafts'"
            :icon="Wrench"
            :selectHighlight="currentView == 'drafts'"
            :isSelected="currentView == 'drafts'"
            @click="currentView = 'drafts'"
            width="150px"
          />
        </div>
        <div class="listNav flexRightRow">
          <BaseButton
            :text="'New workflow'"
            :icon="CirclePlus"
            @click="routerPush(this.$router, '/newboard')"
            width="200px"
          />
          <!-- <BaseButton
            :text="'Temp'"
            @click="routerPush(this.$router, '/temp')"
            width="200px"
          /> -->
        </div>
      </div>
      <div v-if="currentView == 'activeWorkflows'">
        <div
          v-for="workflow in this.activeWorkflows"
          :key="workflow"
          class="wfItem flexSpaceBetweenRow"
          @click="routerPush(this.$router, '/workboards')"
        >
          <div class="wfTitle">{{ workflow.name }}</div>
          <p style="width: 200px">{{ workflow.hours }} hours saved</p>
          <div class="flexLeftRow" style="width: 300px">
            <div class="listTags" v-for="tag in workflow.tags" :key="tag">
              {{ tag }}
            </div>
          </div>
          <div class="hourBreakdownChart">
            <div v-for="hour in workflow.hourBreakdown" :key="hour">
              <div class="hourItem" :style="{ height: 2 * hour + 'px' }"></div>
              <div class="hourBase"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentView == 'drafts'">
        <div
          v-for="workflow in this.drafts"
          :key="workflow"
          @click="routerPush(this.$router, '/workboards')"
          class="wfItem flexSpaceBetweenRow"
        >
          <div class="wfTitle">{{ workflow.name }}</div>
          <p>not live yet</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
// import SideNav from "../../../components/utilities/SideNav.vue";
import NavButton from "../../../components/buttons/NavButton.vue";
import BaseButton from "../../../components/buttons/BaseButton.vue";
import { Zap, Wrench, CirclePlus } from "lucide-vue-next";
import routerPush from "../../../utilities";

export default {
  name: "Boards",
  components: {
    NavButton,
    BaseButton,
    // SideNav,
  },
  methods: {
    routerPush,
  },
  beforeUnmount() {},
  setup() {
    return {};
  },
  data() {
    return {
      Zap,
      Wrench,
      CirclePlus,
      currentView: "activeWorkflows",
      activeWorkflows: [
        {
          id: 1,
          name: "Workflow 1",
          hours: "44",
          tags: ["Google Sheets", "Airtable", "Typeform"],
          hourBreakdown: [
            3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3,
            0,
          ],
          status: "active",
        },
        {
          id: 2,
          name: "Workflow 2",
          hours: "31",
          tags: ["Stripe", "Monday.com", "Email"],
          hourBreakdown: [
            0, 4, 5, 9, 3, 10, 0, 0, 0, 0, 2, 4, 0, 4, 5, 9, 3, 10, 0, 0, 0, 0,
            2, 4,
          ],
          status: "active",
        },
        {
          id: 3,
          name: "Workflow 3",
          hours: "87",
          tags: ["Email"],
          hourBreakdown: [
            3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0, 3,
            0,
          ],
          status: "active",
        },
        {
          id: 4,
          name: "Workflow 4",
          hours: "12",
          tags: ["Google Drive", "Slack"],
          hourBreakdown: [
            3, 1, 0, 9, 7, 11, 12, 8, 9, 1, 2, 4, 3, 1, 0, 9, 7, 11, 12, 8, 9,
            1, 2, 4,
          ],
          status: "active",
        },
      ],
      drafts: [
        {
          id: 1,
          name: "Draft 1",
          status: "draft",
        },
        {
          id: 2,
          name: "Draft 2",
          status: "draft",
        },
      ],
    };
  },
};
</script>

<style scoped>
#listpage {
  position: absolute;
  left: 51px;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f9f4ff;
  padding-top: 100px;
}
.lists {
  width: 1000px;
}
.listNav {
  width: 200px;
}
.wfItem {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
}
.wfItem:hover {
  background: #f0e5ff;
  border: thin solid #d3c2ff;
}
.hourBreakdownChart {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: fit-content;
  height: 20px;
}
.hourItem {
  background: #721cff;
  width: 8px;
  margin-left: 3px;
}
.hourBase {
  width: 8px;
  background: #a8a8a8;
  height: 1px;
  margin-left: 3px;
}
.listTags {
  background: #dadada;
  border-radius: 7px;
  padding: 2px 5px;
  margin: 2px;
  font-size: 12px;
  color: #636363;
}
.wfTitle {
  width: 200px;
}
</style>
